import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-perio-exam-feature-flag-disabled-modal',
  imports: [TranslatePipe],
  templateUrl: './perio-exam-feature-flag-disabled-modal.component.html',
  styleUrl: './perio-exam-feature-flag-disabled-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioExamFeatureFlagDisabledModalComponent {
  private readonly dialogRef = inject(DialogRef);

  protected onOkButtonClicked(): void {
    this.dialogRef.close();
  }
}
